module.exports = __webpack_public_path__ + "media/images/icon__calendar-2a816184d1092d8c4a037b48551b48a8.png";